import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, Shield, Truck, CreditCard } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#050505] border-t border-[#222222]">
      {/* Trust badges */}
      <div className="border-b border-[#222222]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-[#111111] border border-[#222222] flex items-center justify-center">
                <Shield className="w-6 h-6 text-[#00F0FF]" />
              </div>
              <div>
                <p className="text-[#F8F8F8] font-medium">10 Year Warranty</p>
                <p className="text-[#666666] text-sm">Premium Vetrox Film</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-[#111111] border border-[#222222] flex items-center justify-center">
                <Truck className="w-6 h-6 text-[#00F0FF]" />
              </div>
              <div>
                <p className="text-[#F8F8F8] font-medium">Australia Post</p>
                <p className="text-[#666666] text-sm">$35 Flat Rate Shipping</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-[#111111] border border-[#222222] flex items-center justify-center">
                <CreditCard className="w-6 h-6 text-[#00F0FF]" />
              </div>
              <div>
                <p className="text-[#F8F8F8] font-medium">Secure Payment</p>
                <p className="text-[#666666] text-sm">eWay Secured</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_ppf-kit-customizer/artifacts/aut6oyje_PHOTO-2026-02-07-23-08-24.jpg"
              alt="DIY PPF Kit"
              className="h-16 w-auto mb-4"
            />
            <p className="text-[#666666] text-sm leading-relaxed">
              Premium DIY Paint Protection Film kits for Australian vehicles. Custom cut Vetrox film with professional quality results.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#F8F8F8] font-semibold mb-4 tracking-wide">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => handleLinkClick('/products')} className="footer-link text-sm text-left">
                  Products
                </button>
              </li>
              <li>
                <button onClick={() => handleLinkClick('/warranty')} className="footer-link text-sm text-left">
                  Warranty
                </button>
              </li>
              <li>
                <button onClick={() => handleLinkClick('/returns')} className="footer-link text-sm text-left">
                  Returns Policy
                </button>
              </li>
              <li>
                <button onClick={() => handleLinkClick('/contact')} className="footer-link text-sm text-left">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-[#F8F8F8] font-semibold mb-4 tracking-wide">Products</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => handleLinkClick('/products')} className="footer-link text-sm text-left">
                  Whole Body Gloss
                </button>
              </li>
              <li>
                <button onClick={() => handleLinkClick('/products')} className="footer-link text-sm text-left">
                  Whole Body Matt
                </button>
              </li>
              <li>
                <button onClick={() => handleLinkClick('/products')} className="footer-link text-sm text-left">
                  Coloured Film
                </button>
              </li>
              <li>
                <button onClick={() => handleLinkClick('/products')} className="footer-link text-sm text-left">
                  Essential Package
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#F8F8F8] font-semibold mb-4 tracking-wide">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-[#00F0FF]" />
                <a href="mailto:Sales@DIYPPFKit.com.au" className="footer-link text-sm">Sales@DIYPPFKit.com.au</a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-[#00F0FF]" />
                <a href="tel:0411911858" className="footer-link text-sm">0411 911 858</a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-[#00F0FF] mt-0.5" />
                <span className="footer-link text-sm">PO Box 426<br />St Ives NSW 2075</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#222222] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#666666] text-sm">
            © {new Date().getFullYear()} DIY PPF Kit. All rights reserved.
          </p>
          <p className="text-[#666666] text-sm mt-2 md:mt-0">
            Australian Owned & Operated
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
